import { render } from "./recentContentBlock.vue?vue&type=template&id=67234a43&scoped=true&ts=true"
import script from "./recentContentBlock.vue?vue&type=script&lang=ts"
export * from "./recentContentBlock.vue?vue&type=script&lang=ts"

import "./recentContentBlock.vue?vue&type=style&index=0&id=67234a43&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67234a43"]])

export default __exports__